export default function R_Lists() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Lists Component</h1>
      <p>This is the R_Lists tutorial section.</p>
    </div>
  );
}
